import {
  Box,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Container,
  Grid,
  Icon,
  LinearProgress,
  linearProgressClasses,
  Typography
} from '@mui/material';
import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';
import { Helmet } from 'react-helmet';
import PerfectScrollbar from 'react-perfect-scrollbar';
import VerticalBarGraph from 'src/components/pages/ahc/ahcDashboard/VerticalBarGraph';
import DateRange from 'src/components/common/DateRange';
import theme from 'src/theme';
import goodalipi from 'src/plugins/goodalipi';
import { _axios } from 'src/plugins/axios';
import commonService from 'src/service/common';
import _, { round } from 'lodash';
import moment from 'moment';
import CustomDoughnut from 'src/components/common/customDoughnut';
import SearchRecords from './SearchRecords';
import { format } from 'date-fns';

const titleForOverTime =  goodalipi.get('user') && goodalipi.get('user').baseProfileData && goodalipi.get('user').baseProfileData.entityId == 1006639 ? 'Consultations Over Time' : 'Gold Activations Over Time';
const pmEntitId = goodalipi.get('user') ? goodalipi.get('user').corporateType : null;
const options = {
  animation: {
    duration: 1,
    onComplete: function () {
      // baseImg = chartRef.current.toBase64Image();
      // console.log(chartRef.current);
    }
  },
  indexAxis: 'y',
  cornerRadius: 20,
  layout: {
    padding: 0
  },
  maintainAspectRatio: false,
  responsive: true,
  interaction: {
    intersect: false,
    mode: 'y'
  },
  plugins: {
    legend: {
      display: false
    },
    tooltip: {
      callbacks: {
        title: function (tooltipItem) {
          return tooltipItem[0].label.replace(',', ' ');
        },
        footer: function (tooltipItems) {
          let sum = 0;
          if (tooltipItems.length == 1) {
            return;
          }
          tooltipItems.forEach(function (tooltipItem) {
            sum += tooltipItem.parsed.x;
          });
          return 'Total: ' + sum;
        }
      }
    }
  },
  scales: {
    x: {
      ticks: {
        color: '#aaaaaa'
      },
      stacked: true,
      grid: {
        drawBorder: false,
        borderDash: [2],
        borderDashOffset: [2]
      }
    },
    y: {
      stacked: true,
      ticks: {
        color: theme.palette.secondary.main,
        beginAtZero: true,
        min: 0
      },
      grid: {
        display: false,
        drawBorder: false
      }
    }
  }
};
const specl = {
  labels: ['Self', 'Mother', 'Father', 'Wife', 'Son'],
  datasets: [
    {
      label: 'Dataset 1',
      data: [1000, 200, 300, 500, 70],
      // borderColor: Utils.CHART_COLORS.red,
      backgroundColor: '#a3cbff',
      barPercentage: 0.5,
      // barThickness: 10,
      maxBarThickness: 10,
      minBarLength: 3
    }
  ]
};

const month = {
  labels: [
    'Jan',
    'Feb',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ],
  datasets: [
    {
      label: 'Dataset 1',
      data: [800, 200, 300, 500, 703, 213, 324, 546, 234, 687, 566, 345],
      // borderColor: Utils.CHART_COLORS.red,
      backgroundColor: '#a3cbff',
      barPercentage: 0.5,
      // barThickness: 10,
      maxBarThickness: 10,
      minBarLength: 3
    }
  ]
};
const consults = {
  labels: ['Pediatrics', 'Sexology', 'Dermatology', 'Sexology', 'General'],
  datasets: [
    {
      label: 'Dataset 1',
      data: [100, 200, 300, 500, 703],
      // borderColor: Utils.CHART_COLORS.red,
      backgroundColor: '#a3cbff',
      barPercentage: 0.5,
      // barThickness: 10,
      maxBarThickness: 10,
      minBarLength: 3
    }
  ]
};
export default class GoldDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // statusCount: goodalipi.get('isMinor') == "isBooleantrue" ? _.filter(masterDataCountItems, function (o) { return o.statusName == "Total"; }) : _.filter(masterDataCountItems, function (o) { return o.statusName == "Total"; }),
      totalConsultations: 0,
      self: 0,
      family: 0,
      mainData: {},
      ageData: {},
      topicData: {},
      benfCount: {},
      packageList: [],
      satisfaction: {
        keys: [1, 2, 3, 4, 5],
        values: [0, 0, 0, 0, 0],
        totalResponses: 0,
        overAllRating: 0
      },
      legends: [
        {
          value: 'Gold Activations',
          color: '#1778f2'
        },
        {
          value: 'Gold Not Activated',
          color: '#ff0000'
        }
      ],
      packageActive: 0,
      loading: {
        benfWiseUtilisation: false,
        topicWiseUtlisation: false,
        gender_age: false,
        subsSplit: false,
        rating: false,
        eligible: false
      },
      server: {
        benfWiseUtilisation: true,
        topicWiseUtlisation: true,
        gender_age: true,
        subsSplit: true,
        rating: true,
        eligible: true
      },
      male: 0,
      female: 0,
      filter: {
        duration: 2021,
        campus: [],
        location: [],
        bene: [],
        payment: '',
        dateRange: [],
        entityRequested: ''
      },
      filterOptions: {
        durationList: [2015, 2016, 2017, 2018, 2019, 2020, 2021],
        campusList: [],
        locationList: [],
        beneList: [],
        paymentList: [],
        entityRequested: goodalipi.get('globalHRgroup') ? goodalipi.get('globalHRgroup') : []
      },
      totalEligble: 0,
      activations: 0,
      notctivated: 0,
      totalGenderEligible: 0
    };
    this.isMinor = goodalipi.get('isMinor') == 'isBooleantrue' ? true : false;
  }

  applyFilters() {
    const payload = {};
    if (this.state.filter.entityRequested) {
      payload.globalHR = true;
      payload.entityRequested = this.state.filter.entityRequested;
    }
    if (this.state.filter.dateRange.length == 2) {
      let startDate = new Date(this.state.filter.dateRange[0])
      let endDate = new Date(this.state.filter.dateRange[1])
      payload["apptDateBegin"] = startDate.getFullYear() + "-" + (("0" + (startDate.getMonth() + 1)).slice(-2)) + "-" + ("0" + startDate.getDate()).slice(-2)
      payload["apptDateEnd"] = endDate.getFullYear() + "-" + (("0" + (endDate.getMonth() + 1)).slice(-2)) + "-" + ("0" + endDate.getDate()).slice(-2)
    }

    this.fetchTopicWiseUtlisation(payload);
    this.fetchBenfWiseUtilisation(payload);
    if (!this.isMinor) {
      this.fetchRating(payload);
    }
    this.fetchGender(payload);
    this.fetchAgeDistribtion(payload);
    this.fetchSubsSplit(payload);
    this.fetchEligible(payload);
    
  }

  setLoadingServer(name, loading, server) {
    this.setState((prev) => ({
      loading: {
        ...prev.loading,
        [name]: loading
      },
      server: {
        ...prev.server,
        [name]: server
      }
    }));
  }

  fetchTopicWiseUtlisation(obj = {}) {
    this.setLoadingServer('topicWiseUtlisation', true, true);
    let payLoad = {};
    // payLoad["service"] = 1
    // payLoad["year"] = this.state.filter.duration
    Object.keys(obj).map((item) => {
      payLoad[item] = obj[item];
    });
    _axios
      .post('gold/topicWiseUtlisation', payLoad, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          const labels_topic = [],
            data_topic = [];
          response.data.result.forEach((each) => {
            if (each.topic) {
              labels_topic.push(each.topic.split(' '));
              data_topic.push(each.value);
            }
          });
          const topicdata = {
            labels: labels_topic,
            datasets: [
              {
                data: data_topic,
                backgroundColor: '#a3cbff',
                barPercentage: 0.5,
                maxBarThickness: 10,
                minBarLength: 3
              }
            ]
          };
          this.setState({
            topicData: topicdata
          });
          this.setLoadingServer('topicWiseUtlisation', false, true);
        } else {
          this.setLoadingServer('topicWiseUtlisation', false, false);
        }
      })
      .catch((error) => {
        this.setLoadingServer('topicWiseUtlisation', false, false);
      });
  }

  fetchBenfWiseUtilisation(obj = {}) {
    this.setLoadingServer('benfWiseUtilisation', true, true);
    let payLoad = {};
    // payLoad["service"] = 1
    // payLoad["year"] = this.state.filter.duration
    Object.keys(obj).map((item) => {
      payLoad[item] = obj[item];
    });
    _axios
      .post('gold/benfWiseUtilisation', payLoad, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          const labels_ben = [],
            data_ben = [];
          _.keys(response.data.result).forEach((each) => {
            if (each) {
              labels_ben.push(each);
              data_ben.push(response.data.result[each]);
            }
          });
          const bendata = {
            labels: labels_ben,
            datasets: [
              {
                data: data_ben,
                backgroundColor: '#a3cbff',
                barPercentage: 0.5,
                maxBarThickness: 10,
                minBarLength: 3
              }
            ]
          };
          this.setState({
            benfCount: bendata,
            totalConsultations:
              response.data.consultSplit && response.data.consultSplit.total
                ? response.data.consultSplit.total
                : 0,
            self:
              response.data.consultSplit && response.data.consultSplit.Myself
                ? response.data.consultSplit.Myself
                : 0,
            family:
              response.data.consultSplit && response.data.consultSplit.Family
                ? response.data.consultSplit.Family
                : 0
          });
          this.setLoadingServer('benfWiseUtilisation', false, true);
        } else {
          this.setLoadingServer('benfWiseUtilisation', false, false);
        }
      })
      .catch((error) => {
        this.setLoadingServer('benfWiseUtilisation', false, false);
      });
  }

  fetchRating(obj = {}) {
    let payLoad = {};
    // payLoad["service"] = 1
    // payLoad["year"] = this.state.filter.duration
    Object.keys(obj).map((item) => {
      payLoad[item] = obj[item];
    });
    this.setLoadingServer('rating', true, true);
    _axios
      .post('gold/ratingDistribution', payLoad, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          const data = [0, 0, 0, 0, 0];
          for (let index = 0; index < response.data.result.length; index++) {
            const element = response.data.result[index];
            if (element['ratings']) {
              data[element['ratings'] - 1] = round(element['percentage']);
            }
          }
          this.setState((prev) => ({
            satisfaction: {
              ...prev.satisfaction,
              values: data,
              totalResponses: response.data.totalCount
                ? response.data.totalCount
                : 0,
              overAllRating: response.data.avgRating
                ? response.data.avgRating
                : 0
            }
          }));
          this.setLoadingServer('rating', false, true);
        } else {
          this.setLoadingServer('rating', false, false);
        }
      })
      .catch((error) => {
        this.setLoadingServer('rating', false, false);
      });
  }

  fetchGender(obj = {}) {
    let payLoad = {};
    // payLoad["service"] = 1
    // payLoad["year"] = this.state.filter.duration
    Object.keys(obj).map((item) => {
      payLoad[item] = obj[item];
    });
    this.setLoadingServer('gender_age', true, true);
    _axios
      .post('gold/genderWiseCnt', payLoad, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          let m = 0,
            f = 0;
          response.data.result.forEach((each) => {
            if (['f', 'female'].indexOf(each.gender.toLowerCase()) > -1) {
              f += each.value ? each.value : 0;
            } else if (['m', 'male'].indexOf(each.gender.toLowerCase()) > -1) {
              m += each.value ? each.value : 0;
            }
          });
          this.setState((prev) => ({
            male: m,
            female: f,
            totalGenderEligible: m + f
          }));
          this.setLoadingServer('gender_age', false, true);
        } else {
          this.setLoadingServer('gender_age', false, false);
        }
      })
      .catch((error) => {
        this.setLoadingServer('gender_age', false, false);
      });
  }

  setActivationDate(dateArr) {
    if (dateArr && dateArr[0] && dateArr[1]) {
      this.fetchSubsSplit({
        apptDateBegin: moment(dateArr[0]).format('YYYY-MM-DD'),
        apptDateEnd: moment(dateArr[1]).add(1,'days').format('YYYY-MM-DD')
      });
    }
  }

  fetchSubsSplit(obj = {}) {
    let payLoad = {};
    // payLoad["service"] = 1
    // payLoad["year"] = this.state.filter.duration
    Object.keys(obj).map((item) => {
      payLoad[item] = obj[item];
    });
    let lastSelectedDays = {};
    _.forEach([...Array(12).keys()], (days) => {
      lastSelectedDays[days + 1] = 0;
    });
    this.setLoadingServer('subsSplit', true, true);
    _axios
      .post('gold/subscriptionSplit', payLoad, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          response.data.result.forEach((each) => {
            if (each.month in lastSelectedDays) {
              lastSelectedDays[each.month] = each.value ? each.value : 0;
            }
          });
          console.log(Object.values(lastSelectedDays));
          const data = {
            labels: Object.keys(lastSelectedDays).map((item) => {
              return moment(item, 'M').format('MMM');
            }),
            datasets: [
              {
                data: Object.values(lastSelectedDays),
                backgroundColor: '#a3cbff',
                barPercentage: 0.5,
                maxBarThickness: 10,
                minBarLength: 3
              }
            ]
          };
          console.log(data);
          this.setState({
            mainData: data
          });
          this.setLoadingServer('subsSplit', false, true);
        } else {
          this.setLoadingServer('subsSplit', false, false);
        }
      })
      .catch((error) => {
        this.setLoadingServer('subsSplit', false, false);
      });
  }

  fetchAgeDistribtion(obj = {}) {
    let payLoad = {};
    // payLoad["service"] = 1
    // payLoad["year"] = this.state.filter.duration
    Object.keys(obj).map((item) => {
      payLoad[item] = obj[item];
    });
    _axios
      .post('gold/ageWiseSplit', payLoad, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          const labels_age = [],
            data_age = [];
          _.keys(response.data.result).forEach((each) => {
            labels_age.push(each);
            data_age.push(response.data.result[each]);
          });
          const agedata = {
            labels: labels_age,
            datasets: [
              {
                data: data_age,
                backgroundColor: '#1778f2',
                barPercentage: 0.5,
                maxBarThickness: 10,
                minBarLength: 3
              }
            ]
          };
          this.setState((prev) => ({
            ageData: agedata
          }));
        } else {
        }
      })
      .catch((error) => {});
  }

  fetchEligible(obj = {}) {
    let payLoad = {};
    // payLoad["service"] = 1
    // payLoad["year"] = this.state.filter.duration
    Object.keys(obj).map((item) => {
      payLoad[item] = obj[item];
    });
    this.setLoadingServer('eligible', true, true);
    _axios
      .post('gold/totalEligible', payLoad, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          let t = 0,
            a = 0,
            n = 0;
          _.keys(response.data.result).forEach((each) => {
            if (each == 'NotActivated') {
              n = response.data.result[each] ? response.data.result[each] : 0;
            } else if (each == 'TotalActivations') {
              a = response.data.result[each] ? response.data.result[each] : 0;
            } else if (each == 'TotalEligible') {
              t = response.data.result[each] ? response.data.result[each] : 0;
            }
          });
          this.setState((prev) => ({
            totalEligble: t,
            activations: a,
            notctivated: n
          }));
          this.setLoadingServer('eligible', false, true);
        } else {
          this.setLoadingServer('eligible', false, false);
        }
      })
      .catch((error) => {
        this.setLoadingServer('eligible', false, false);
      });
  }

  componentDidMount() {
    this.fetchTopicWiseUtlisation();
    this.fetchBenfWiseUtilisation();
    if (!this.isMinor) {
      this.fetchRating();
    }
    this.fetchGender();
    this.fetchAgeDistribtion();
    this.fetchSubsSplit();
    this.fetchEligible();
  }
  render() {
    return (
      <>
        <Helmet>
          <title>MB Gold | Dashboard</title>
        </Helmet>
        <Box
          sx={{
            backgroundColor: 'background.default',
            minHeight: '100%',
            py: 2
          }}
        >
          <Container maxWidth={false}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Card
                  sx={{
                    width: '100%',
                    borderRadius: 4,
                    p: 2,
                    boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                  }}
                >
                  <SearchRecords
                    filterOptions={this.state.filterOptions}
                    filter={this.state.filter}
                    setFilters={(value) => this.setState({ filter: value })}
                    onRefresh={() => this.applyFilters()}
                  />

                  <Grid item container xs={12} spacing={2}>
                   {/* {!pmEntitId && <Grid
                      sx={{ mt: 2, position: 'relative' }}
                      container
                      direction="row"
                      xs={12}
                      sm={4}
                      justifyContent="center"
                      alignItems="center"
                    >
                      <CardHeader
                        title={
                          'Total Eligible (' + this.state.totalEligble + ')'
                        }
                        sx={{ position: 'absolute', top: 0, left: 0 }}
                      />
                      <Grid item xs={12} sm={6}>
                        <Box
                          sx={{
                            height: 170
                          }}
                          className={
                            this.state.loading.eligible ? 'display-center' : ''
                          }
                        >
                          {this.state.loading.eligible ? (
                            <CircularProgress size={30} />
                          ) : (
                            <CustomDoughnut
                              backgroundColor={this.state.legends.map(
                                (eac) => eac.color
                              )}
                              labels={[
                                'Gold Activations',
                                'Gold Not Activated'
                              ]}
                              data={[
                                this.state.activations,
                                this.state.notctivated
                              ]}
                            />
                          )}
                        </Box>
                      </Grid>
                      <Grid sx={{ px: 2, mb: 2 }} direction="row" container>
                        {this.state.legends.map((val, idx) => (
                          <Grid
                            key={idx}
                            container
                            item
                            xs={6}
                            direction="row"
                            alignItems="center"
                            justifyContent="center"
                          >
                            <Box
                              sx={{
                                height: 14,
                                width: 14,
                                borderRadius: 1,
                                mr: 1,
                                bgcolor: val['color'],
                                cursor: 'pointer'
                              }}
                            />
                            <Typography variant="caption">
                              {val.value}
                            </Typography>
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>} */}
                    <Grid
                      sx={{ borderLeft: '1px solid #ddd', mt: 2 }}
                      container
                      xs={12}
                      sm={4}
                    >
                      <Card
                        sx={{
                          width: '100%'
                        }}
                        elevation={0}
                      >
                        <CardHeader
                          title={
                            'Gender wise consultation utilization  (' +
                            this.state.totalGenderEligible +
                            ')'
                          }
                          sx={{ pb: 1 }}
                        />
                        <Grid item container xs={12} direction="row">
                          <Grid item xs={12} sm={6}>
                            <Box
                              sx={{
                                height: 140
                              }}
                              className={
                                this.state.loading.gender_age
                                  ? 'display-center'
                                  : ''
                              }
                            >
                              {this.state.loading.gender_age ? (
                                <CircularProgress size={30} />
                              ) : (
                                <CustomDoughnut
                                  count={this.state.male}
                                  title="Male"
                                />
                              )}
                            </Box>
                            <Typography
                              variant="h6"
                              sx={{ fontSize: 10, textAlign: 'center' }}
                            >
                              {' '}
                              Total Eligible Male: {this.state.male}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <Box
                              sx={{
                                height: 140
                              }}
                              className={
                                this.state.loading.gender_age
                                  ? 'display-center'
                                  : ''
                              }
                            >
                              {this.state.loading.gender_age ? (
                                <CircularProgress size={30} />
                              ) : (
                                <CustomDoughnut
                                  count={this.state.female}
                                  backgroundColor={['#ff92a6']}
                                  title="Female"
                                />
                              )}
                            </Box>
                            <Typography
                              variant="h6"
                              sx={{ fontSize: 10, textAlign: 'center' }}
                            >
                              {' '}
                              Total Eligible Female: {this.state.female}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                    <Grid
                      sx={{ borderLeft: '1px solid #ddd', mt: 2 }}
                      container
                      xs={12}
                      sm={4}
                    >
                      <Card elevation={0}>
                        <CardHeader title="Age wise consultation utilization" />
                        <Grid item xs={12} sx={{ px: 3, mb: 3 }}>
                          <Box
                            sx={{
                              height: 140
                            }}
                            className={
                              this.state.loading.gender_age
                                ? 'display-center'
                                : ''
                            }
                          >
                            {this.state.loading.gender_age ? (
                              <CircularProgress size={30} />
                            ) : (
                              <Bar
                                options={options}
                                data={this.state.ageData}
                              ></Bar>
                            )}
                          </Box>
                        </Grid>
                      </Card>
                    </Grid>
                  </Grid> 
                </Card>
              </Grid>

              <Grid item xs={12} sm={!this.isMinor ? 8 : 12}>
                <Grid item>
                  <Card
                    sx={{
                      width: '100%',
                      borderRadius: 4,
                      p: 1,
                      boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                    }}
                  >
                    <Grid container justifyContent="space-between">
                      <CardHeader title= {titleForOverTime} />
                      {/* <Grid item xs={12} sm={6} sx={{ marginTop: '5px' }}>
                        <DateRange
                          noHelperText={true}
                          helperTextValue={'Subscription'}
                          boxsize="small"
                          onDateChange={(value) => {
                            this.setActivationDate(value);
                          }}
                        />
                      </Grid> */}
                    </Grid>
                    <CardContent>
                      <PerfectScrollbar>
                        <Box
                          sx={{
                            height: '240px',
                            minWidth: '700px',
                            width: `calc(${
                              this.state.mainData.labels
                                ? this.state.mainData['labels'].length
                                : 5
                            }*90px)`
                          }}
                          className={
                            this.state.loading.subsSplit ? 'display-center' : ''
                          }
                        >
                          {this.state.loading.subsSplit ? (
                            <CircularProgress size={30} />
                          ) : (
                            <VerticalBarGraph data={this.state.mainData} />
                          )}
                        </Box>
                      </PerfectScrollbar>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>

              <Grid
                sx={{ display: this.isMinor ? 'none' : 'block' }}
                item
                container
                xs={12}
                sm={4}
                spacing={2}
              >
                {false && (
                  <Grid item xs={12}>
                    <Card
                      sx={{
                        width: '100%',
                        borderRadius: 4,
                        p: 1,
                        pb: 3,
                        boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                      }}
                    >
                      <CardHeader
                        title="Employee Satisfaction"
                        sx={{ pb: 1 }}
                      />
                      <Box sx={{ px: 2 }}>
                        {/* <Grid container direction="row" alignItems="center">
                        <Icon sx={{ fontSize: 15 }}>
                          <img className="fit-to-parent" src="/static/images/employees.svg"></img>
                        </Icon>
                        <Typography variant="caption" sx={{ color: '#868898', ml: 1 }}>{this.state.satisfaction.totalResponses} Responses</Typography>
                      </Grid> */}
                        {this.state.satisfaction.keys.map((val, idx) => (
                          <Grid
                            key={idx}
                            container
                            direction="row"
                            alignItems="center"
                            sx={{ my: 1 }}
                          >
                            <Typography variant="h6">{val}</Typography>
                            <Box sx={{ flexGrow: 1, mx: 1 }}>
                              <LinearProgress
                                sx={{
                                  height: 12,
                                  [`& .${linearProgressClasses.bar}`]: {
                                    backgroundColor: '#f7b900'
                                  },
                                  [`&.${linearProgressClasses.colorPrimary}`]: {
                                    backgroundColor: '#f7f7f7'
                                  }
                                }}
                                variant="determinate"
                                value={this.state.satisfaction.values[idx]}
                              />
                            </Box>
                            <Typography variant="h6">
                              {this.state.satisfaction.values[idx]}%
                            </Typography>
                          </Grid>
                        ))}
                      </Box>
                    </Card>
                  </Grid>
                )}
                {!this.isMinor && (
                  <Grid item xs={12}>
                    <Card
                      sx={{
                        width: '100%',
                        borderRadius: 4,
                        p: 2,
                        height: 100,
                        boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                      }}
                    >
                      <Typography variant="h5">Overall Rating</Typography>
                      <br />
                      {this.state.loading.rating ? (
                        <CircularProgress size={30} />
                      ) : (
                        <Typography variant="h2">
                          {this.state.satisfaction.overAllRating}/5
                        </Typography>
                      )}
                    </Card>
                  </Grid>
                )}
              </Grid>
              <Grid item container xs={12} sm={6} spacing={2}>
                <Grid item container xs={12}>
                  <Card
                    sx={{
                      width: '100%',
                      // height: '100px',
                      borderRadius: 4,
                      p: 2,
                      boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                    }}
                  >
                    <Grid
                      item
                      container
                      xs={12}
                      direction="row"
                      alignItems="center"
                      spacing={2}
                    >
                      <Grid
                        sx={{ mt: 2 }}
                        item
                        container
                        direction="column"
                        xs={12}
                        sm={4}
                      >
                        <Icon fontSize="medium">
                          <img
                            style={{
                              width: 'auto',
                              height: 'auto',
                              maxWidth: '100%',
                              maxHeight: '100%'
                            }}
                            alt="edit"
                            src="/static/images/totalConsultations.svg"
                          />
                        </Icon>
                        <Typography variant="caption" sx={{ marginTop: 1 }}>
                          Toal Consultations
                        </Typography>
                        <Typography variant="h4">
                          {this.state.totalConsultations}
                        </Typography>
                      </Grid>
                      <Grid
                        sx={{ borderLeft: '1px solid #ddd', mt: 2 }}
                        item
                        direction="column"
                        container
                        xs={12}
                        sm={4}
                      >
                        <Icon fontSize="medium">
                          <img
                            style={{
                              width: 'auto',
                              height: 'auto',
                              maxWidth: '100%',
                              maxHeight: '100%'
                            }}
                            alt="edit"
                            src="/static/images/self.svg"
                          />
                        </Icon>
                        <Typography variant="caption" sx={{ marginTop: 1 }}>
                          For Self
                        </Typography>
                        <Typography variant="h4">{this.state.self}</Typography>
                      </Grid>
                      <Grid
                        sx={{ borderLeft: '1px solid #ddd', mt: 2 }}
                        item
                        direction="column"
                        container
                        xs={12}
                        sm={4}
                      >
                        <Icon fontSize="medium">
                          <img
                            style={{
                              width: 'auto',
                              height: 'auto',
                              maxWidth: '100%',
                              maxHeight: '100%'
                            }}
                            alt="edit"
                            src="/static/images/family.svg"
                          />
                        </Icon>
                        <Typography variant="caption" sx={{ marginTop: 1 }}>
                          For Family
                        </Typography>
                        <Typography variant="h4">
                          {this.state.family}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid item xs={12}>
                  <Card
                    sx={{
                      width: '100%',
                      borderRadius: 4,
                      p: 1,
                      boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                    }}
                  >
                    <CardHeader title="All Consultations - Speciality wise" />
                    <CardContent>
                      <PerfectScrollbar>
                        <Box
                          sx={{
                            height: '180px',
                            minWidth: '540px',
                            width: `calc(${
                              this.state.topicData.labels
                                ? this.state.topicData['labels'].length
                                : 4
                            }*100px)`
                          }}
                          className={
                            this.state.loading.topicWiseUtlisation
                              ? 'display-center'
                              : ''
                          }
                        >
                          {this.state.loading.topicWiseUtlisation ? (
                            <CircularProgress size={30} />
                          ) : (
                            <VerticalBarGraph data={this.state.topicData} />
                          )}
                        </Box>
                      </PerfectScrollbar>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
              {goodalipi.get('isMinor') == 'isBooleanfalse' && (
                <Grid item xs={12} sm={6}>
                  <Card
                    sx={{
                      width: '100%',
                      borderRadius: 4,
                      p: 2,
                      boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                    }}
                  >
                    <CardHeader title="Beneficiary Information" />
                    <CardContent>
                      <PerfectScrollbar>
                        <Box
                          sx={{
                            maxHeight: 300,
                            px: 2
                          }}
                        >
                          <Box
                            sx={{
                              height: `calc(${
                                this.state.benfCount.labels
                                  ? this.state.benfCount['labels'].length
                                  : 7
                              }*40px)`
                            }}
                          >
                            {this.state.loading.benfWiseUtilisation ? (
                              <CircularProgress size={30} />
                            ) : (
                              <Bar
                                options={options}
                                data={this.state.benfCount}
                              ></Bar>
                            )}
                          </Box>
                        </Box>
                      </PerfectScrollbar>
                    </CardContent>
                  </Card>
                </Grid>
              )}
            </Grid>
          </Container>
        </Box>
      </>
    );
  }
}
